import React from "react";

const SelectContainer = (props) => {
  const { options,tab, name, onChange, value, onKeyPress,widthValue } = props;
  return (
    <div>
      <select
       tabIndex={tab}
        onChange={onChange}
        style={{ height: "40px", marginTop: "2px", width: `${widthValue}` }}
        onKeyPress={onKeyPress}
        name={name}
        id={name}
        value={value}
      >
        {options.map((option) => {
          return (
            <option key={option.value} value={option.value}>
              {option.key}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default SelectContainer;
